import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';
import { DefaultToastComponent } from './default-toast.component';

const MATERIAL_MODULES = [MatButtonModule, MatIconModule];

@NgModule({
  imports: [TranslocoModule, ...MATERIAL_MODULES],
  exports: [DefaultToastComponent],
  declarations: [DefaultToastComponent],
  providers: [],
})
export class DefaultToastComponentModule {}
